import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class ForInvestorsUpcomingEvents extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get title() {
    return get(this, '_tytul.value', '');
  }

  get subtitle() {
    return get(this, '_podtytul.value', '');
  }

  get date() {
    return get(this, '_data.value', '');
  }

  get href() {
    return get(this, '_link.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/ForInvestorsUpcomingEvents.model.js